export default function deleteSessionCookie(cookieDomain: string) {
  document.cookie = `__session=; max-age=0; path=/; domain=${cookieDomain}`
}
